import { InfoCard } from '../../../components/info';
import { P2Alert, P2Button, P2TextDescription } from 'react-bootstrap-common-script';
import { ApplicationStep3 } from '../../../models/classes/ApplicationStep3.class';
import { useCallback, useEffect, useRef, useState } from 'react';
import { HDBLinks } from '../../../utils/shared/links';
import { HoldingTypeEnum } from '../../../models/enum/holding-type.enum';

interface JointTenancyCardProps{
  ConveyancingSetFormValue:(value:any)=>void;
  ConveyancingValue:ApplicationStep3;
}
function JointTenancyCard({...props}:JointTenancyCardProps) {
  const [saveAlertShow, setSaveAlertShow] = useState<boolean>(false);
  const divRef = useRef<any>();

  const handleJointTenancyValues = useCallback(()=>{
    if(!props.ConveyancingValue.is_holding_type_confirm){
      setSaveAlertShow(false);
    }
    props.ConveyancingSetFormValue({...props.ConveyancingValue, is_holding_type_confirm: !props.ConveyancingValue.is_holding_type_confirm});
  },[props])

  const handleClickOutside = useCallback((event:any) => {

    if(props.ConveyancingValue.holding_type === HoldingTypeEnum.joint_tenancy 
      && !props.ConveyancingValue.is_holding_type_confirm && 
      divRef.current && !divRef.current.contains(event.target)
      ){
          setSaveAlertShow(true);
      }

  },[props, divRef]);

  useEffect(() => {
    // Add click event listener to the document
    document.addEventListener('click', handleClickOutside);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]); 

  return (
    <div ref={divRef}>
      <InfoCard style={{backgroundColor:"#FFF"}} title={"Joint Tenancy"} description={<div style={{marginTop:32}}>
        <P2TextDescription description_size={"1.125rem"} description={<p style={{fontSize:"1.125rem"}}>Under <a rel="noopener noreferrer" href={HDBLinks.joint_tenancy} target="_blank" className="polymer-text-links">joint tenancy</a>, the co-owners own the whole interest in the flat together. In joint tenancy, the right of survivorship applies. This means that upon the demise of any joint owner, their interest in the flat would automatically be passed on to the remaining co-owners. This is regardless of whether the deceased joint owner has left behind a Will.</p>}/>
        {saveAlertShow && <div style={{ marginTop: 24 }}>
          <P2Alert variant={"danger"} text={"Please confirm the manner of holding type before proceeding."}></P2Alert>
        </div>}
        <div style={{display:"flex", justifyContent:"flex-start", margin:"32px 0 12px"}} className="polymer-button-wrapper">
          <P2Button onClick={handleJointTenancyValues} variant={"outline-primary"}>{props.ConveyancingValue.is_holding_type_confirm ? "Edit holding type" :"Confirm holding type"}</P2Button>
        </div>

      </div>} />
    </div>
  )
}

export default JointTenancyCard